import { Offcanvas } from 'react-bootstrap';
import React from 'react';
import { usePanelContext } from './PanelContext';

export const GlobalSidePanels: React.FC = () => {
    const { activePanels, closePanel } = usePanelContext();

    return (
        <>
            {activePanels.map((panel) => (
                <Offcanvas
                    key={panel.id}
                    show
                    onHide={() => closePanel(panel.id)}
                    placement={panel.placement || 'end'}
                    style={{ width: panel.width || '300px' }}
                    scroll
                    backdrop={panel.backdrop}
                >
                    {panel.title && (
                        <Offcanvas.Header
                            closeButton
                            style={{ borderBottom: '1px solid lightgray', height: '77px' }}
                        >
                            <Offcanvas.Title>
                                <span style={{ fontSize: 20, fontWeight: 500 }}>{panel.title}</span>
                            </Offcanvas.Title>
                        </Offcanvas.Header>
                    )}
                    <Offcanvas.Body>{panel.content}</Offcanvas.Body>
                </Offcanvas>
            ))}
        </>
    );
};
